import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import { ocrAgentInfo, ocrOrgInfo } from "@/service/image-service";
import { cnnumtonum } from "@/tools/util";
var containsChinese = function containsChinese(str) {
  var isChineseReg = new RegExp("[\\u4E00-\\u9FFF]+");
  return isChineseReg.test(str);
};

export default {
  dealOrgData: function dealOrgData(cardData, userType) {
    var regChiness = /[\u4e00-\u9fa5]/g;

    for (var key in cardData) {
      if (key === "biz_license_start_time" || key === "BIRTHDAY" || key === "biz_license_operating_period" || key === "birthday" || key === "validity") {
        cardData[key] = this.formatDate(cardData[key]);
      }
    }

    if (cardData.type == "business_license") {
      if (userType == "1") {
        cardData.CUST_FNAME = cardData.biz_license_company_name || "";
      }

      if (userType == "2") {
        cardData.PRO_MANAGER_NAME = cardData.biz_license_company_name || "";
      }

      cardData.ID_TYPE = "10";

      cardData.ID_CODE = cardData.biz_license_credit_code || "";

      cardData.ID_BEG_DATE = cardData.biz_license_start_time.replace(/年|月|日/g, "") || "";

      if (cardData.biz_license_operating_period && cardData.biz_license_operating_period.indexOf("至") != -1) {
        var dateArr = cardData.biz_license_operating_period.split("至");
        cardData.ID_BEG_DATE = dateArr[0].replace(/年|月|日/g, "");
        dateArr[1] && (cardData.ID_EXP_DATE = dateArr[1] === "长期" ? "30001231" : dateArr[1].replace(/年|月|日/g, ""));
      } else if (cardData.biz_license_operating_period) {
        cardData.ID_EXP_DATE = cardData.biz_license_operating_period.replace(/年|月|日/g, "");
      }

      cardData.ID_ADDR = cardData.biz_license_address || "";

      cardData.BUSINESS_RANGE = cardData.biz_license_scope || "";

      cardData.BIRTHDAY = cardData.biz_license_start_time.replace(/年|月|日/g, "") || "";
      cardData.biz_license_reg_capital = cardData.biz_license_reg_capital.replace("人民币", "");
      if (cardData.biz_license_reg_capital.indexOf("万") != -1) {
        if (!isNaN(parseInt(cardData.biz_license_reg_capital))) {
          cardData.biz_license_reg_capital = cardData.biz_license_reg_capital.replace(regChiness, "") * 10000;
        } else {
          var n = cardData.biz_license_reg_capital.replace("元整", "").replace("元", "");
          cardData.biz_license_reg_capital = cnnumtonum(n + "");
        }
      }
      cardData.REGISTER_FUND = cardData.biz_license_reg_capital + "";
    } else if (cardData.type == "第二代身份证") {
      cardData.CITIZENSHIP = "CHN";

      cardData.ID_ADDR = cardData.address || "";

      cardData.USER_FNAME = cardData.name || "";

      cardData.ID_TYPE = "00";

      cardData.ID_CODE = cardData.id_number || "";

      cardData.BIRTHDAY = cardData.birthday.replace(/年|月|日/g, "") || "";

      cardData.SEX = cardData.sex == "男" ? "0" : "1" || "";
    } else if (cardData.type == "第二代身份证背面" && cardData.validity) {
      cardData.ID_EXP_DATE = cardData.validity ? cardData.validity.split("-")[1].replaceAll(".", "") : "";
    }

    var arr = ["ID_BEG_DATE", "ID_EXP_DATE", "AGENT_ID_EXP_DATE", "AGENT_BIRTHDAY", "BIRTHDAY"];
    _.each(arr, function (key) {
      if (cardData[key] && containsChinese(cardData[key])) {
        cardData[key] = "";
      }
    });
    return cardData;
  },
  ocrIdentify: function ocrIdentify(imgSrc, flag, idType, ocrIdentifyType, userType) {
    var _this = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var res, cardData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              res = "";
              cardData = "";

              if (!(idType == 10)) {
                _context.next = 8;
                break;
              }

              _context.next = 5;
              return ocrOrgInfo(imgSrc.split(";base64,")[1]);

            case 5:
              res = _context.sent;
              _context.next = 11;
              break;

            case 8:
              _context.next = 10;
              return ocrAgentInfo(imgSrc.split(";base64,")[1]);

            case 10:
              res = _context.sent;

            case 11:
              cardData = _this.dealOrgData(res.Data[0].data, userType);
              return _context.abrupt("return", cardData);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  formatDate: function formatDate(str) {
    var regExp = new RegExp("(?<=\/|-|\\.|\:|\\b|T)\\d{1}(?=\/|-|\\.|\:|\\b|T)", "g");
    return str.replace(regExp, "0$&");
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/service/ocr-service.js
// module id = 1075
// module chunks = 2